import PropTypes from 'prop-types'
import { Button, Upload } from 'antd'

const FileInput = ({
  fileFieldName,
  fileFieldId,
  labelTitle,
  onChange,
  isDisabled,
  multiple = false,
  accept,
  className = '',
}) => {
  return (
    <Upload
      name={fileFieldName}
      multiple={multiple}
      disabled={isDisabled}
      showUploadList={false}
      accept={accept}
      beforeUpload={(file) => {
        onChange(file)
        return false
      }}
    >
      <Button
        id={fileFieldId}
        type="link"
        disabled={isDisabled}
        className={
          className ||
          (isDisabled
            ? 'text-gray-500'
            : 'text-blue-500 cursor-pointer')
        }
      >
        {labelTitle}
      </Button>
    </Upload>
  )
}

FileInput.propTypes = {
  fileFieldName: PropTypes.string.isRequired,
  fileFieldId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTitle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  multiple: PropTypes.bool,
  className: PropTypes.string,
}

export default FileInput
